import React from 'react';

interface Props {
  diffText: string;
}

const WfDiffArrow: React.FC<Props> = ({ diffText }) => {
  if (diffText.includes('증가') || diffText.includes('+')) {
    const m = diffText.match(/([+-]?\d+)/);
    return (
      <span className="wf-diff-arrow wf-diff-increase">
        <span className="wf-arrow-icon">🔺</span>
        <span className="wf-diff-value">{m ? m[1] : ''}</span>
      </span>
    );
  }
  if (diffText.includes('감소') || diffText.includes('-')) {
    const m = diffText.match(/(-?\d+)/);
    return (
      <span className="wf-diff-arrow wf-diff-decrease">
        <span className="wf-arrow-icon">🔻</span>
        <span className="wf-diff-value">{m ? m[1] : ''}</span>
      </span>
    );
  }
  return (
    <span className="wf-diff-arrow wf-diff-same">
      <span className="wf-arrow-icon">➖</span>
      <span className="wf-diff-value">0</span>
    </span>
  );
};

export default WfDiffArrow;
